<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="card">
        <div class="card_date">
          {{ article?.createdAt }}
        </div>
        <div class="editor">
          <div v-html="article?.content"></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from '@common/store/modules/board';
import * as boardTypes from '@common/store/modules/board/types';
import * as commonActions from '@common/store/modules/common/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';

export default {
  data() {
    return {
      articleId: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters({
      article: boardTypes.ARTICLE,
    }),
  },
  beforeDestroy() {
    this[commonActions.SET_CUSTOM_HEADER_TEXT](undefined);
  },
  async created() {
    await this[boardTypes.FETCH_ARTICLE]({ id: this.articleId }).then(() => {
      const title = this.article.title;
      this[commonActions.SET_CUSTOM_HEADER_TEXT](title);
    });
  },
  methods: {
    ...commonMapActions([commonActions.SET_CUSTOM_HEADER_TEXT]),
    ...mapActions([boardTypes.FETCH_ARTICLE]),
  },
};
</script>
